<template>
  <scoped>
    <TextInput
      :value="selection"
      :title="title"
      :readOnly="readOnly"
      @click="display = true"
    />
    <ContentModal v-if="display">
      <Option
        v-model:selection="selection"
        :options="options"
        :readOnly="readOnly"
        @update="update()"
      />
      <Button
        title="Close"
        @click="display = false"
      />
    </ContentModal>
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import Option from "@/components/inputs/option.vue"
  import ContentModal from "@/components/modals/content.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {ref} from "vue"

  defineProps({
    options: {
      default: null,
      required: true,
      type: Array<string>
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  })

  const emits = defineEmits(["update"])
  const selection = defineModel("selection", {
    default: null,
    required: true,
    type: String
  })
  
  const display = ref<boolean>(false)

  function update() {
    display.value = false
    emits("update")
  }
</script>
